var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"share"}},[_c('img',{attrs:{"src":_vm.imgurl,"alt":""}}),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.html)}},[_vm._v("html")]),_c('div',{staticStyle:{"width":"100%","height":"173px"}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }